import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.642 16.244C18.042 14.3 19 12.164 19 10a7 7 0 1 0-14 0c0 2.163.958 4.3 2.358 6.244 1.39 1.93 3.1 3.506 4.319 4.505.2.163.446.163.646 0 1.219-.999 2.928-2.575 4.319-4.504m-3.052 6.052C16.175 20.179 21 15.492 21 10a9 9 0 1 0-18 0c0 5.492 4.825 10.18 7.41 12.296a2.485 2.485 0 0 0 3.18 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }